import React from "react"
import useWindowDimensions from "../../../hooks/useWindowDimensions"
import { mdWidth } from "../../../static/sizes/widths"
import useHeadings from "../hooks/useHeadings"
import useScrollSpy from "../hooks/useScrollSpy"
import DesktopAgenda from "./DesktopAgenda/DesktopAgenda"
import MobileAgenda from "./MobileAgenda/MobileAgenda"

type Props = {
  title: string
  isShown?: boolean
  mobileHeight?: string
}

function Agenda({ title, isShown = true, mobileHeight }: Props) {
  const headings = useHeadings()
  const { width } = useWindowDimensions()
  const activeId = useScrollSpy(
    headings.map(({ id }) => id),
    { rootMargin: "0% 0% 0% 0%" }
  )

  const handleScroll = (id: string) => {
    document
      .getElementById(id)
      ?.scrollIntoView({ block: "center", behavior: "smooth" })
  }

  if (width && width < mdWidth) {
    return (
      <MobileAgenda
        activeId={activeId}
        headings={headings}
        onScroll={handleScroll}
        title={title}
        listHeight={mobileHeight}
      />
    )
  }

  return (
    <DesktopAgenda
      activeId={activeId}
      headings={headings}
      isShown={isShown}
      onScroll={handleScroll}
      title={title}
    />
  )
}

export default Agenda
